export function generateRandomCode() {
  let randomNumber = Math.floor(Math.random() * 10000);

  let paddedNumber = randomNumber.toString().padStart(4, "0");

  return paddedNumber;
}
